import { ref } from "vue"
import { defineStore } from "pinia"

export interface Toast {
  id: number
  tone: "success" | "error" | "info"
  message: string
}

export const useToastStore = defineStore("toasts", () => {
  const items = ref<Toast[]>([])
  let sequence = 0

  function push(message: string, tone: Toast["tone"] = "info", timeoutMs = 5000): void {
    const id = ++sequence
    items.value.push({ id, tone, message })
    window.setTimeout(() => remove(id), timeoutMs)
  }

  function remove(id: number): void {
    items.value = items.value.filter((item) => item.id !== id)
  }

  return { items, push, remove }
})
